module.exports = __webpack_public_path__ + "static/co-card-9ccb8022ece0073c768f601a44d58c17.png";